import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class LinkBlock extends Vue {
    @Prop({required: true, type: String})
    public text: string;

    @Prop({required: true, type: String})
    public link: string;
}
